import getPhoneType from './getPhoneType';

const isIos = (): boolean => {
  return getPhoneType() === 'iphone' || getPhoneType() === 'ipad';
};

export default isIos;
